import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'
import { push } from 'react-router-redux'
import { BasicForm, InputField, TextareaField, SelectField, Form, FileInput } from 'react-serial-forms'
import t from 'tcomb-form'
import { WebsiteRefinement, WebsiteTransformer } from '../utils/tcomb-utils'
import { doSaveOrganizationApplication } from  '../actions'
import { UserIsAuthenticated, UserIsVerified } from '../utils/auth'
import { EmailRefinement } from '../utils/tcomb-utils'
import DocumentMeta from 'react-document-meta'
import { loadCollageOrganizations } from '../actions';
// import Dropzone class from utils directory
import DropZonePhoto from '../utils/dropzonephoto';




const NewOrganizationApplicationSchema = t.struct({
  name: t.String,

  website: WebsiteRefinement,

  contact_first_name: t.String,
  contact_last_name: t.String,
  contact_email: EmailRefinement,

  job_title: t.String,

  
  is_non_profit: t.Boolean,
  about: t.String,
  services: t.String,

  facebook: WebsiteRefinement,
  instagram: WebsiteRefinement,
  twitter: WebsiteRefinement,
  linkedin: WebsiteRefinement,

  info_email: EmailRefinement,

  address: t.String,

  
});


const formOptions = {
  auto: 'none',
  fields: {
    name: {
      error: 'Please provide the name of your organization',
      attrs: {
        placeholder: 'What is the name of your organization?',
        error: 'this field is required'
      },
      label: <div className="formLabel"><span>Required *</span></div>,
    },

    website: {
      error: 'Please provide be a valid website address or url',
      transformer: WebsiteTransformer,
      type: 'text',
      attrs: {
        placeholder: 'What is your web address?'
      },
      label: <div className="formLabel"><span>*</span></div>,
    },

    contact_first_name: {
      error: 'Please provide your first name',
      attrs: {
        placeholder: 'Your first name',
        error: 'this field is required'
      },
      label: <div className="formLabel"><span>*</span></div>,
    },

    contact_email: {
      error: 'Please provide a valid email address',
      type: 'email',
      attrs: {
        placeholder: 'Email'
      },
      label: <div className="formLabel"><span>*</span></div>,
    },

    contact_last_name: {
      error: 'Please provide your last name',
      attrs: {
        placeholder: 'Your last name',
        error: 'this field is required'
      },
      label: <div className="formLabel"><span>*</span></div>,
    },

    job_title: {
      error: 'Please provide your job title',
      attrs: {
        placeholder: 'What is your job title?',
        error: 'this field is required'
      },
      label: <div className="formLabel"><span>*</span></div>,
    },

    

    is_non_profit: {
      error: 'We are only accepting non-profit applications at this time',
      factory: t.form.Checkbox,
      label: <div className="checkboxLabel">Is your organization a non-profit? <span>*</span></div>
    },


    about: {
      error: 'This field is required',
      type: 'textarea',
      attrs: {
        placeholder: 'ABOUT - Tell us about your organization'
      },
      label: <div className="formLabel"><span>*</span></div>,
    },

    services: {
      error: 'This field is required',
      type: 'textarea',
      attrs: {
        placeholder: 'SERVICE OVERVIEW - Tell us about your services and programs that you are offering'
      },
      label: <div className="formLabel"><span>*</span></div>,
    },

    facebook: {
      error: 'Please provide be a valid Facebook address or url',
      transformer: WebsiteTransformer,
      type: 'text',
      attrs: {
        placeholder: 'Facebook link'
      }
    },

    instagram: {
      error: 'Please provide be a valid Instagram address or url',
      transformer: WebsiteTransformer,
      type: 'text',
      attrs: {
        placeholder: 'Instagram link'
      }
    },

    twitter: {
      error: 'Please provide be a valid Twitter address or url',
      transformer: WebsiteTransformer,
      type: 'text',
      attrs: {
        placeholder: 'X (Twitter) link'
      }
    },

    linkedin: {
      error: 'Please provide be a valid LinkedIn address or url',
      transformer: WebsiteTransformer,
      type: 'text',
      attrs: {
        placeholder: 'LinkedIn link'
      }
    },

    info_email: {
      error: 'Please provide a valid email address',
      type: 'email',
      attrs: {
        placeholder: 'Email for inquiries (info@ etc.)'
      }
    },

    address: {
      error: 'This field is required',
      type: 'textarea',
      attrs: {
        placeholder: 'Organization HQ address'
      },
      label: <div className="formLabel"><span>*</span></div>,
    },

    

  }
};

const bannerProportion = .37;

class ApplyToList extends Component {
  state = {
    formOptions: formOptions,
    formValue: {},
    throwMissingLogoError: false,
    logoWrapperWidth: 128,
    logoWrapperHeight: 128,
    logoFileType: null,
    logoBinaryFile: null,
    logoBinaryFileLoaded: false,

    throwMissingBannerError: false,
    bannerWrapperWidth: null,
    bannerWrapperHeight: null,
    bannerFileType: null,
    bannerBinaryFile: null,
    bannerBinaryFileLoaded: false,
  };

  onFormChange = formValue => {
    this.setState({formValue});
  };

  componentDidMount() {
    if (typeof(window) !== "undefined") {
      window.scrollTo(0,0)
    }
    this.updateDimensions();
    
  }

  componentDidUpdate(prevProps) {
    // Typical usage (don't forget to compare props):
    if (this.props.browser !== prevProps.browser) {
        this.updateDimensions();
    }
  }

  updateDimensions = () => {
    let { browser } = this.props;
    let wrapperWidth = 0;
    let wrapperHeight = 0;
    // Set max width
    if (browser.width > 1140) {
      wrapperWidth = 850 + 'px';
      wrapperHeight = 315 + 'px';
    } else if (browser.width > 850) {
      wrapperWidth = 700 + 'px';
      wrapperHeight = 700 * bannerProportion + 'px';
    } else {
      wrapperWidth = browser.width - 20 + 'px';
      wrapperHeight = browser.width * bannerProportion + 'px';
    }

    this.setState({
        bannerWrapperWidth: wrapperWidth,
        bannerWrapperHeight: wrapperHeight
    });
  }

  resetForm = () => {
    this.setState({formValue: {
      name: '',
      contact_first_name: '',
      contact_last_name: '',
      job_title: '',
      website: '',
      services: '',
      form_submitted: false,
    }});
  };

  dataURItoBlob = (dataURI) => {
    // convert base64 to raw binary data held in a string
    const byteString = atob(dataURI.split(',')[1])

    // separate out the mime component
    const mimeString = dataURI
      .split(',')[0]
      .split(':')[1]
      .split(';')[0]

    // write the bytes of the string to an ArrayBuffer
    const ab = new ArrayBuffer(byteString.length)
    const ia = new Uint8Array(ab)
    for (let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i)
    }
    return new Blob([ab], { type: mimeString })
  }

  getBlobFileType = (data) => {
    const byteString = data.split(';');
    let fileType = byteString[0].split('/')[1];
    return fileType;
  }

  // Set states for logo binary file
  handleLogoBinaryFile = (file) => {
    this.setState({logoBinaryFile: file});
    this.setState({logoBinaryFileLoaded: true});
  }

  // Set states for banner binary file
  handleBannerBinaryFile = (file) => {
    this.setState({bannerBinaryFile: file});
    this.setState({bannerBinaryFileLoaded: true});
  }


  // Handle logo upload
  handleLogoUpload = (file) => {
    if (file) {
      let reader = new FileReader();
      reader.onload = () => {
        var binaryStr = reader.result;
        let fileType = this.getBlobFileType(binaryStr);
        this.setState({logoFileType: fileType});
        var blob = this.dataURItoBlob(binaryStr);
        this.handleLogoBinaryFile(blob);
      }
      reader.readAsDataURL(file)
    }
  };

  // Handle banner upload
  handleBannerUpload = (file) => {
    if (file) {
      let reader = new FileReader();
      reader.onload = () => {
        var binaryStr = reader.result;
        let fileType = this.getBlobFileType(binaryStr);
        this.setState({bannerFileType: fileType});
        var blob = this.dataURItoBlob(binaryStr);
        this.handleBannerBinaryFile(blob);
      }
      reader.readAsDataURL(file)
    }
  };

  handleSubmit = e => {
    e.preventDefault();
    const value = this.refs.applyForm.getValue();
    
    if(!value) {
      return;
    }
    else {
      let data = new FormData();
      for (var key in value) {
        if (key == 'website' && value[key] == undefined) {
          data.append(key, '')
        } else {
          data.append(key, value[key])
        } 
      }
      // Handle logo upload
      
      if (this.state.logoBinaryFile !== null) {
        // reset throwMissingLogoError to false if previously false
        this.setState({throwMissingLogoError: false})

        let logoName = value.name + "-logo." + this.state.logoFileType;
        data.append('image_logo', this.state.logoBinaryFile, logoName)
      } else {
        this.setState({throwMissingLogoError: true})
        return;
      }


      // Handle banner upload
      if (this.state.bannerBinaryFile !== null) {
        // reset throwMissingBannerError to false if previously false
        this.setState({throwMissingBannerError: false})
        let bannerName = value.name + "-banner." + this.state.bannerFileType;
        data.append('image_banner', this.state.bannerBinaryFile, bannerName)
      } else {
        this.setState({throwMissingBannerError: true})
        return;
      }

      this.props.doSaveOrganizationApplication(data);
      this.setState({formSubmitted: true});
      

      if (typeof(window) !== "undefined") {
        window.scrollTo(0,0)
      }
    }
  };

  render() {

    let { user } = this.props.auth;
    let { browser } = this.props;
    let buttonCollage = '';
    let collageHeader = <span>
      Apply to List with WorldWideWomen
    </span>;

    let logoPhoto = '';
    let logoError = '';
    if (this.state.throwMissingLogoError) {
      logoError = <div style={{
        backgroundColor: 'red',
        width: '100%',
        padding: '0.5rem',
        color: '#ffffff',
        marginBottom: '1.0rem'
      }} className="leaderSpotlightPhotoError">Please upload your Logo.</div>
    }

    let bannerPhoto = '';
    let bannerError = '';
    if (this.state.throwMissingBannerError) {
      bannerError = <div style={{
        backgroundColor: 'red',
        width: '100%',
        padding: '0.5rem',
        color: '#ffffff',
        marginBottom: '1.0rem'
      }} className="leaderSpotlightPhotoError">Please upload your Banner.</div>
    }
    

    const meta = {
      title: 'WorldWideWomen | Apply to be listed in global women’s directory',
        description: "List your company, organization or service on WorldWideWomen, a global online directory for women. Promote your business and connect with customers.",
      canonical: 'https://worldwidewomen.co/organizations/apply',
    }
    

    let bannerText = <div className="organization-applyBannerText global-banner-text">
      <h2>Apply to list your services on WorldWideWomen!</h2>
      <p className="tag">A powerful resource to connect to women around the world</p>
    </div>;
    let content = (
      <div className="organization-applyContent">
        <div className="applyToList-header">
          <h2>Tell us about your organization</h2>
          <h5>We are currently accepting only non-profit organization applications.</h5>
        </div>
        <div className="organization-applyContentForm">
          <form onSubmit={this.handleSubmit}>
            <t.form.Form ref="applyForm" onChange={this.onFormChange} value={this.state.formValue} type={NewOrganizationApplicationSchema} options={this.state.formOptions} />
            
          </form>
        </div>


        <div className="organization-applyContent dropZone-logoWrapper">
          <p>Upload your organization's logo, (128px X 128px) by dropping your logo file below or click on the logo example.<span style={{color: 'red'}}>*</span></p>

          <div id="" style={{marginTop: '-1rem', padding: '0 0px'}} className="logoWrapper logoWrapper-photo">
          
            {logoError}

            <DropZonePhoto picture={logoPhoto}
              imgWidth={this.state.logoWrapperWidth}
              imgHeight={this.state.logoWrapperHeight}
              style={{width: this.state.logoWrapperWidth+'px', height: this.state.logoWrapperHeight+'px'}}
              dropZoneImgClass='applyToList-logoDropzone'
              onChanged={this.handleLogoUpload} />
          </div>
        </div>

        <div className="organization-applyContent dropZone-wrapper">
          <p>Upload your organization's banner, (850px X 315px) by dropping your banner file below or click on the banner example.<span style={{color: 'red'}}>*</span></p>

          <div id="" style={{marginTop: '-1rem', padding: '0 0px'}} className="bannerWrapper bannerWrapper-photo">

            {bannerError}

            <DropZonePhoto picture={bannerPhoto}
              imgWidth={this.state.bannerWrapperWidth}
              imgHeight={this.state.bannerWrapperHeight}
              style={{width: this.state.bannerWrapperWidth, height: this.state.bannerWrapperHeight}}
              dropZoneImgClass='applyToList-bannerDropzone'
              onChanged={this.handleBannerUpload} />
          </div>

          <button onClick={this.handleSubmit} className="organizationApply applyToList-submitBtn" type="submit">Submit</button>

        </div>

    </div>);


    if(this.props.applyOrganization.saved) {

      bannerText = <div className="organization-applyBannerText global-banner-text">
        <div>Thank you!</div>
          <small>Thank you for applying to be listed on the WorldWideWomen website.<br />
            We will review your application and get back to you shortly.</small>
          <div style={{ 'text-align': 'right', 'font-size': '1.8rem'}}>The WorldWideWomen Team</div>
      </div>;

      content = <div className="organization-applyContent">
        <div className="applyToList-header">
          <h2>Thank you!</h2>

          <div className="applyToList-thanksCopy">
            <p>Thank you for applying to be listed on the WorldWideWomen website.</p>

            <p>We will review your application and get back to you shortly.</p>

            <p className="applyToList-WWWSig">The WorldWideWomen Team</p>
          </div>
        </div>
      </div>;

    }

    

    return (
      <div className="content-wrapper">
        <DocumentMeta {...meta} />

        <div className="applyToList-bannerWrapper">
          <div className="applyToList-bannerDesktop"><img src="images/apply_to_list_lp/apply_to_list_form_banner_desktop.jpg" /></div>
          
          <div className="applyToList-bannerMobile"><img src="images/apply_to_list_lp/apply_to_list_form_banner_mobile.jpg" /></div>
          
        </div>

        <div className="organization-apply">
          <div className="content-wrapper">
            {content}
          </div>
        </div>

        
      </div>
    );
  }
}

function mapStateToProps(state) {
  return state;
};

export default connect(
  mapStateToProps,
  {
    push,
    doSaveOrganizationApplication,
    loadCollageOrganizations
  }
)(ApplyToList);



// WEBPACK FOOTER //
// ./src/containers/ApplyToList.jsx